module.exports = __webpack_public_path__ + "static/media/return-of-investment.b8de3311.svg";